const fr = {
  translation: {
    // Navigation
    'home': 'Accueil',
    'about_us': 'À Propos',
    'services': 'Services',
    'contact': 'Contact',
    'locations': 'Emplacements',

    // Home page content
    'hero_title': 'Transport Premium pour Équipages Aériens',
    'hero_title_first_line': 'Transport Premium',
    'hero_title_second_line': 'pour Équipages Aériens',
    'hero_subtitle': 'Nous sommes le principal fournisseur de transport à San Francisco, Los Angeles, Silicon Valley, Floride, New York, Texas et Sydney, Australie.',
    'hero_cta_first_line': 'Parler à',
    'hero_cta_second_line': 'Concierge de',
    'hero_cta_third_line': 'Transport',
    'hero_cta': 'Parler à Notre Concierge de Transport',

    // About section
    'about_title': 'À Propos de Nous',
    'about_description': 'est le principal fournisseur de services de navette pour équipages aériens et hôtels en Amérique du Nord. Depuis près de 30 ans, nous sommes à l\'avant-garde en fournissant des solutions de transport fiables, sûres et efficaces pour les équipages aériens du monde entier.',
    'about_years': 'Années d\'Excellence',
    'about_global_locations': 'Emplacements Mondiaux',
    'about_service': 'Service et Assistance',
    'get_in_touch': 'Parler à Notre Concierge de Transport d\'Équipage Aérien',
    'about_second_paragraph': 'Notre dévouement à l\'excellence, la ponctualité et la satisfaction client a fait de nous le choix préféré de nombreuses compagnies aériennes internationales. Nous comprenons les besoins uniques des équipages aériens et avons adapté nos services pour assurer une expérience confortable et sans stress, de la prise en charge à la dépose.',

    // In Good Company section
    'in_good_company_title': 'En Bonne Compagnie',
    'in_good_company_description': 'Faisant confiance aux principales compagnies aériennes mondiales pour des services de transport fiables et premium.',

    // Testimonials section
    'testimonials_title': 'Ce que Disent Nos Clients',
    'testimonials_description': 'Découvrez pourquoi les principales compagnies aériennes et clients nous choisissent pour leurs besoins en transport.',

    // Testimonial quotes
    'testimonial_1_quote': "J'ai passé un excellent moment à travailler et à finaliser le calendrier d'été de notre équipage avec le responsable d'Airline Crew Transportation.",
    'testimonial_1_author': "SAS Airlines",
    'testimonial_1_company': "Directeur de Station",

    'testimonial_2_quote': "Nous avons enfin trouvé un JOYAU.",
    'testimonial_2_author': "Aish Wedding Services",
    'testimonial_2_company': "PDG et Manager",

    'testimonial_3_quote': "C'était une préoccupation de moins et j'ai été rassuré quand on m'a recommandé Airline Crew Transportation pour le transport de notre équipage de vol et de cabine depuis et vers l'hôtel.",
    'testimonial_3_author': "El-Al Airlines",
    'testimonial_3_company': "Directeur de Station",

    // Services section
    'services_title': 'Nos Services',
    'services_description': 'Découvrez nos options de transport premium, chacune conçue pour répondre à vos besoins spécifiques avec confort et fiabilité.',
    'select_a_service': 'Sélectionner un Service',
    'get_a_quote': 'Obtenir un Devis',

    // Service items
    'service_airport_transfer_title': 'Transfert Aéroport',
    'service_airport_transfer_bullet1': 'Prises en charge et déposes ponctuelles pour des opérations fluides.',
    'service_airport_transfer_bullet2': 'Véhicules propres et bien équipés pour chaque trajet.',

    'service_distressed_passengers_title': 'Transport de Passagers en Détresse',
    'service_distressed_passengers_bullet1': 'Intervention rapide 24/7 pour retards et annulations de vols.',
    'service_distressed_passengers_bullet2': 'Relocalisation efficace vers hôtels ou aéroports alternatifs.',

    'service_any_occasion_title': 'Services Automobiles pour Toute Occasion',
    'service_any_occasion_bullet1': 'Transport premium pour événements et réunions d\'entreprise.',
    'service_any_occasion_bullet2': 'Service professionnel garantissant l\'arrivée reposée des cadres.',

    'service_hotel_transfer_title': 'Transfert Hôtel',
    'service_hotel_transfer_bullet1': 'Coordination parfaite entre hébergements et aéroports.',
    'service_hotel_transfer_bullet2': 'Timing parfait pour départs matinaux et arrivées tardives.',

    'service_flight_cabin_crew_title': 'Navette pour Équipage de Vol et de Cabine',
    'service_flight_cabin_crew_bullet1': 'Service spécialisé comprenant les exigences opérationnelles aériennes.',
    'service_flight_cabin_crew_bullet2': 'Respect strict des protocoles de timing pour horaires d\'équipage.',

    'service_company_shuttle_title': 'Services de Navette d\'Entreprise',
    'service_company_shuttle_bullet1': 'Solutions de transport personnalisées pour employés et cadres.',
    'service_company_shuttle_bullet2': 'Itinéraires réguliers avec suivi temps réel et efficacité coûts.',

    'service_charter_services_title': 'Services d\'Affrètement',
    'service_charter_services_bullet1': 'Solutions de transport sur mesure pour groupes de toutes tailles.',
    'service_charter_services_bullet2': 'Planification logistique professionnelle avec options de flotte personnalisées.',

    // Fleet section
    'fleet_title': 'Notre Flotte',
    'fleet_description': 'Découvrez notre flotte diversifiée de véhicules de luxe, chacun sélectionné pour fournir un confort, un style et une fiabilité exceptionnels pour tous vos besoins de transport.',
    'select_a_vehicle': 'Sélectionner un Véhicule',

    // Fleet items
    'fleet_sedan_title': 'Berline',
    'fleet_sedan_description': 'Berlines de luxe pour les déplacements professionnels avec chauffeurs. Jusqu\'à 3 places.',

    'fleet_suv_title': 'SUV',
    'fleet_suv_description': 'SUV premium offrant un confort spacieux pour petits groupes. Jusqu\'à 6 places.',

    'fleet_sprinter_title': 'Sprinter',
    'fleet_sprinter_description': 'Vans Mercedes-Benz Sprinter avec équipements de luxe pour groupes moyens. Jusqu\'à 14 places.',

    'fleet_minibus_title': 'Minibus',
    'fleet_minibus_description': 'Minibus confortables pour groupes plus importants avec ample espace pour bagages. Jusqu\'à 27 places.',

    'fleet_mini_coach_title': 'Mini Coach',
    'fleet_mini_coach_description': 'Mini coaches offrant un transport premium pour groupes moyens à grands. Jusqu\'à 35 places.',

    'fleet_coach_title': 'Autocar',
    'fleet_coach_description': 'Autocars de luxe de grande taille pour les besoins de transport de grands groupes. Jusqu\'à 55 places.',

    // Fleet vehicle details (for carousel)
    'fleet_van_title': 'Fourgonnette',
    'fleet_van_capacity': 'Capacité de Passagers 1-3',
    'fleet_van_description': 'Nos fourgonnettes exécutives offrent une solution confortable et efficace pour transporter des membres d\'équipage individuels ou de petites équipes.\n\nAvec des intérieurs spacieux, des chauffeurs professionnels et une planification fiable, ces véhicules sont parfaits pour les départs matinaux, les arrivées tardives et tout le reste.',

    'fleet_sprinter_carousel_title': 'Sprinter',
    'fleet_sprinter_carousel_capacity': 'Capacité de Passagers 1-14',
    'fleet_sprinter_carousel_description': 'Nos fourgonnettes Mercedes Sprinter offrent un confort premium pour les groupes de taille moyenne avec un ample espace pour les bagages.\n\nDotés de sièges de luxe, de climatisation et de chauffeurs professionnels, ces véhicules sont idéaux pour les transferts d\'équipage et les besoins de transport de groupe.',

    'fleet_minivan_title': 'Minifourgonnette',
    'fleet_minivan_capacity': 'Capacité de Passagers 1-7',
    'fleet_minivan_description': 'Nos minifourgonnettes confortables sont parfaites pour les petits à moyens groupes d\'équipage nécessitant un transport fiable et efficace.\n\nAvec des arrangements de sièges flexibles et un espace de chargement généreux, ces véhicules offrent l\'équilibre parfait entre confort et praticité pour les besoins des équipages aériens.',

    'fleet_minibus_carousel_title': 'Minibus',
    'fleet_minibus_carousel_capacity': 'Capacité de Passagers 1-25',
    'fleet_minibus_carousel_description': 'Nos minibus spacieux sont conçus pour les groupes d\'équipage plus importants, offrant des sièges confortables et un ample stockage pour les bagages.\n\nAvec la climatisation, des sièges inclinables et une qualité de conduite douce, ces véhicules garantissent que votre équipage arrive reposé et prêt pour ses fonctions.',

    'fleet_minicoach_title': 'Mini Coach',
    'fleet_minicoach_capacity': 'Capacité de Passagers 1-35',
    'fleet_minicoach_description': 'Nos mini coaches premium offrent un transport de luxe pour les grands groupes d\'équipage avec un maximum de confort et de style.\n\nDotés de sièges moelleux, de systèmes de divertissement et de climatisation, ces coaches offrent une expérience de voyage de première classe pour vos transferts d\'équipage les plus importants.',

    // Passenger capacity
    'passenger_capacity': 'Capacité de Passagers',
    'seats': 'sièges',

    // How We Work section
    'how_we_work_title': 'Comment Nous Travaillons',
    'how_we_work_description': 'Notre engagement envers l\'excellence repose sur trois principes fondamentaux qui animent la qualité de notre service.',
    'how_we_work_card1_title': 'Nous Mettons l\'Humain au Premier Plan',
    'how_we_work_card1_description': 'Aucune mission n\'est jamais trop petite, trop grande ou trop complexe pour nous; qu\'il s\'agisse de transporter un ou deux clients ou jusqu\'à 35 membres d\'équipage, vous pouvez compter sur nous.',
    'how_we_work_card2_title': 'Chauffeurs Professionnels',
    'how_we_work_card2_description': 'Nos chauffeurs sont professionnellement agréés, connaissent leurs itinéraires, conduisent leurs véhicules aussi sûrement que possible et traitent toujours nos clients avec des normes élevées et courtoisie.',
    'how_we_work_card3_title': 'Mises à Jour en Temps Réel',
    'how_we_work_card3_description': 'Airline Crew Transportation a établi un centre de répartition centralisé efficace pour gérer la répartition quotidienne des chauffeurs et des bus. Le GPS en temps réel a été mis en place pour assurer la sécurité de tous les passagers.',

    // Contact section
    'contact_title': 'Contactez-Nous',
    'contact_subtitle': 'Prêt à commencer? Contactez-nous aujourd\'hui et laissez-nous gérer vos besoins en transport.',
    'contact_name': 'Nom',
    'contact_name_placeholder': 'Votre Nom Complet',
    'contact_name_required': 'Le nom est requis',
    'contact_email': 'Email',
    'contact_email_placeholder': 'votre@email.com',
    'contact_email_required': 'L\'email est requis',
    'contact_email_invalid': 'Veuillez entrer une adresse email valide',
    'contact_phone': 'Téléphone',
    'contact_phone_placeholder': 'Votre Numéro de Téléphone',
    'contact_subject': 'Sujet',
    'contact_subject_placeholder': 'Sujet',
    'contact_subject_required': 'Le sujet est requis',
    'contact_message': 'Message',
    'contact_message_placeholder': 'Votre message',
    'contact_message_required': 'Le message est requis',
    'contact_submit': 'Envoyer',
    'contact_sending': 'Envoi en cours...',
    'contact_success': 'Votre message a été envoyé avec succès!',
    'contact_thank_you': 'Merci!',
    'contact_success_message': 'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.',
    'contact_send_another': 'Envoyer un Autre Message',
    'contact_hours': 'Heures',
    'contact_24_7': 'Service Client 24/7',

    // Footer
    'footer_copyright': 'Airline Crew Transportation. Tous Droits Réservés.',

    // Locations page
    'locations_page_title': 'Nos Emplacements',
    'locations_page_subtitle': 'Desservant les principales villes du monde avec des services de transport premium',

    // San Francisco location
    'location_sf_title': 'San Francisco',
    'location_sf_description': 'Est le centre culturel, commercial et financier de la Californie du Nord. La ville est l\'une des destinations touristiques les plus populaires. C\'est également le siège social d\'Airline Crew Transportation.',

    // Silicon Valley location
    'location_sv_title': 'Silicon Valley',
    'location_sv_description': 'est la partie sud de la région de la baie de San Francisco. C\'est le siège de nombreuses grandes entreprises technologiques mondiales. Parmi celles-ci figurent les Fortune 1000, Adobe, eBay, Apple, Google, Facebook et Tesla, pour n\'en citer que quelques-unes.',

    // Miami location
    'location_miami_title': 'Miami',
    'location_miami_description': 'Miami vibre toute l\'année avec des lieux de divertissement et des attractions passionnants. Airline Crew Transportation a développé une solide relation de travail avec les principaux hôtels et hébergements de Miami, donnant à votre équipage de vol, aux passagers de première classe et de classe affaires accès au meilleur de Miami.',

    // Los Angeles location
    'location_la_title': 'Los Angeles',
    'location_la_description': 'Los Angeles est la deuxième plus grande ville des États-Unis et la ville la plus peuplée de Californie. La deuxième succursale d\'Airline Crew Transportation est idéalement située à l\'aéroport LAX de Los Angeles.',

    // New York City location
    'location_nyc_title': 'New York',
    'location_nyc_description': 'New York est classée comme la ville la plus photographiée au monde. Ce serait un plaisir d\'avoir votre entreprise rejoindre la liste croissante de clients heureux d\'Airline Crew Transportation, fidèles à nous au fil des années grâce à notre service exceptionnel.',

    // Fort Worth location
    'location_fw_title': 'Fort Worth',
    'location_fw_description': 'Fort Worth, une ville en pleine expansion, bourdonne d\'énergie et d\'un esprit indépendant. Nous travaillons actuellement avec les trois principaux hôtels de Dallas. Nous assurons également le transport pour quatre compagnies aériennes majeures à l\'aéroport de Fort Worth.',

    // Sydney location
    'location_sydney_title': 'Sydney, Australie',
    'location_sydney_description': 'Sydney est une destination que vous n\'oublierez jamais, une ville d\'attractions emblématiques et de plages magnifiques. Airline Crew Transportation à Sydney fournit actuellement des services de navette pour les équipages de vol et de cabine des principales compagnies aériennes et des programmes de navette hôtelière pour les hébergements les plus prestigieux de Sydney.',
  }
};

export default fr; 